import * as React from 'react';

import Modal from 'antd/lib/modal';

import {useHistory, useParams} from 'react-router-dom';

import {TesAuthorCredits, Date} from '@app/components/UI/VetTesCard/VetTesCard';
import {convertAllDates, dateConvert} from '@app/components/Pages/PetMemorial/utils/dateConvert';
import LinkMore from '@app/components/LocalCommon/LinkMore/LinkMore';
import {rest} from '@app/components/Api';
import {VetTestimonialsRes} from '@app/objects/VetTestimonialsRes';
import {MemorialsRes} from '@app/objects/PetMemorial';
import imagePlaceholder from '@app/images/image-placeholder.png';
import {bodyOverflowRemove, bodyOverflowTransform} from '@app/components/LocalCommon/Utils/bodyOverflowTransform';
import {getImagePath} from '@app/objects/Image';

interface CurrentTestimonial extends VetTestimonialsRes {
	datePost: Date;
}
const TestimonialCardModal = ({tesModalVisible, setTesModalVisible, outerModalProps}) => {
	const [currentTestimonial, setCurrentTestimonial] = React.useState<CurrentTestimonial>();
	const [mainImage, setMainImage] = React.useState((currentTestimonial?.avatar && currentTestimonial?.avatar) || undefined);
	const history = useHistory();
	const params: { id?: string | undefined } = useParams();

	const closeModal = () => {
		const id = params.id;
		const outerItem = outerModalProps.filter(item => id && item.id === +id);
		history.push('/veterinarian-testimonials');
		setTesModalVisible(false);
	};

	const imageAltCapture = currentTestimonial && currentTestimonial.user && `Lap of Love Veterinary Hospice ${currentTestimonial.city ? currentTestimonial.city : ''}, 
		${currentTestimonial.state ? currentTestimonial.state : ''} Testimonial for Dr. ${currentTestimonial.user.firstName} ${currentTestimonial.user.lastName} 
		${currentTestimonial.firstName ? `by ${currentTestimonial.firstName} ${currentTestimonial.lastName}` : ''}`;

	React.useEffect(() => {
		!params.id && history.push('/veterinarian-testimonials/');
		!params.id && setTesModalVisible(false);
	}, [params.id]);

	React.useEffect(() => {
		setMainImage(currentTestimonial?.avatar);
	}, [currentTestimonial]);

	React.useEffect(() => {
		bodyOverflowTransform(tesModalVisible);
	}, [tesModalVisible]);

	React.useEffect(() => {
		const id = params.id;
		const outerItem = outerModalProps.filter(item => id && item.id === +id);
		const getTestimonialFromList = () => {
			const dates = convertAllDates(null, null, outerItem[0]?.dateCreated);
			const testimonialFromList = {
				testimonial: outerItem[0],
				datePost: dates.datePost
			};
			setCurrentTestimonial({...outerItem[0], datePost: dates.datePost});
		};
		outerModalProps.length ?
			getTestimonialFromList() :

			id && rest.get<VetTestimonialsRes>(`v1/testimonials/${id}`)
				.then((res) => {
					const datePost = dateConvert(res as unknown as MemorialsRes).datePost;
					setCurrentTestimonial({...res, datePost: datePost});
					setTesModalVisible(true);
				});

	}, [params]);

	return (
		<Modal
			wrapClassName="pet-mem-modal modal-wrap"
			visible={tesModalVisible}
			onOk={() => setTesModalVisible(false)}
			onCancel={() => {
				closeModal();
			}}
			width={1037}
			getContainer="#vet-testimonials"
			// afterClose={() => bodyOverflowRemove()}
		>
			<div className="pet-mem-modal__content">
				<div className="pet-mem-modal__container">
					<header className="pet-mem-modal__content-header">
						<div className="pet-mem-modal__content-header-title">
							<h4>{`Dr. ${currentTestimonial?.user?.firstName} ${currentTestimonial?.user?.lastName}`}</h4>
						</div>
					</header>
					{
						currentTestimonial?.avatar ?
							<div className="pet-mem-modal__content-gallery">
								<img
									src={mainImage !== imagePlaceholder ? getImagePath(mainImage, 420) : mainImage}
									alt={imageAltCapture}
									className={'pet-mem-modal__content-gallery-main_single'}
									onError={() => {
										setMainImage(imagePlaceholder);
									}}
								/>
							</div> : null
					}

					<div className="pet-mem-modal__content-topic" style={{marginTop: '32px'}}>
						<p>
							{currentTestimonial?.message}
						</p>
					</div>
					<TesAuthorCredits
						firstName={currentTestimonial?.firstName}
						lastName={currentTestimonial?.lastName}
						city={currentTestimonial?.city}
						state={currentTestimonial?.state}
						date={currentTestimonial?.datePost}
					/>
					<div className = "vet-tes-card__look-more">
						{currentTestimonial?.user?.firstName &&
						<>
							{
								currentTestimonial?.user?.areaUrl &&
								<LinkMore
									linkMoreCaption={`View Dr. ${currentTestimonial?.user?.firstName}'s biography`}
									linkMoreLink={
										`/find-a-vet/${currentTestimonial?.user?.area.state}/${currentTestimonial?.user?.areaUrl}/veterinarians?veterinarian=${currentTestimonial?.user?.id}`}
								/>
							}

							{
								currentTestimonial.petMemorial &&

								<LinkMore
									linkMoreCaption={`View ${currentTestimonial.petMemorial.petName}'s memorial`}
									linkMoreLink={`/pet-memorial/${currentTestimonial.petMemorial.id}`}/>
							}
						</>
						}
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default TestimonialCardModal;